

































































import { BlTextAv } from '@bukalapak/bazaar-mweb'
import Vue from 'vue'
import TermsNavigation from './TermsNavigation.vue'
import { TncContent, TncContents } from '~/constants/terms/tnc-content'

export default Vue.extend({
  name: 'TncContent',
  components: {
    BlTextAv,
    TermsNavigation,
  },
  data: () => ({
    contents: TncContents,
  }),
  computed: {
    contentsWithTitle(): TncContent[] {
      return this.contents.filter(content => content.title)
    },
  },
})
